module.exports = __webpack_public_path__ + "img/contact-icon.a3da6416.png";